import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import AllianceTopTemplate from '@/features/agent/alliance/templates/AllianceTopTemplate';

const allianceSearchSchema = z.object({
  tab: z.enum(['applications', 'settings', 'agents']).optional().catch(undefined),
  q: z.string().optional(),
  sort: z
    .enum(['updated_at_desc', 'applied_at_desc', 'applied_at_asc'])
    .optional()
    .catch(undefined),
  status: z.string().optional(),
  agentId: z.string().optional(),
});

export const Route = createFileRoute('/agent/alliance/')({
  component: Alliance,
  staticData: { title: 'アライアンス' },
  validateSearch: allianceSearchSchema,
  beforeLoad: async () => {
    const response = await fetch('/agent/api/iam.json');
    if (!response.ok) {
      throw redirect({ to: '/agent' });
    }
    const data = await response.json();
    if (!data.is_alliance_enabled) {
      throw redirect({ to: '/agent' });
    }
  },
});

function Alliance() {
  return (
    <>
      <AllianceTopTemplate />
    </>
  );
}
